import { ViewModelBase } from "../Base";

export class AssetInCollectionModel extends ViewModelBase {
  AssetCollectionId?: number;

  AssetId?: number;

  AssetTitle?: string;
}
